import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import Swal from 'sweetalert2';
import { CarruselService } from '../services/carrusel.service';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { BannerItem, BannerListRequest } from 'src/common/interfaces/Banner.interface';

@Component({
  selector: 'app-order-banners',
  templateUrl: './order-banners.component.html',
  styleUrls: ['./order-banners.component.scss']
})
export class OrderBannerComponent implements OnInit {
  @Output() ordenCambiado = new EventEmitter<{ lista: BannerItem[], cambioDetectado: boolean }>();

  // Secuencia de IDs original ("1,2,3,4,5")
  ordenOriginalIds: string = '';
  listaBanners: BannerItem[] = [];
  attempts: number = 0;
  userData = JSON.parse(localStorage.getItem("usuario"));

  constructor(
    private ngxService: NgxUiLoaderService,
    private bannerService: CarruselService,
  ) {}
  
  ngOnInit() {
    this.getBannersList()
  }

  async getBannersList() {
    this.ngxService.start();
    try {
      if (this.attempts > 2) {
        this.ngxService.stop();
        return this.showAlert(
          'Error al obtener banners', 
          `Lo sentimos, hubo un problema en el servicio, favor de volver a intentar.`
        )
      }
      const requestData: BannerListRequest = {
        udn: parseInt(this.userData.idCliente),
        pagina: 1,
        paginasTotales: 10000,
        idSector: null
      }

      const bannerList = await this.bannerService.getBannersOrderList(requestData);
      this.listaBanners = bannerList.slice(0, 6);
      this.ordenOriginalIds = this.listaBanners.map(b => b.idBanner).join(',');
      // Emitimos 'false' para deshabilitar el botón Guardar
      this.ordenCambiado.emit({
        lista: this.listaBanners,
        cambioDetectado: false
      });
      this.ngxService.stop();
    } 
    catch(err) {
      this.attempts++;
      console.log(err, 'INTENTO: ', this.attempts);
      setTimeout(() => {
        this.getBannersList();
        this.ngxService.stop();
      }, 1000);
    }
  }

  drop(event: CdkDragDrop<any[]>) {
    moveItemInArray(this.listaBanners, event.previousIndex, event.currentIndex);
    
    this.listaBanners = this.listaBanners.map((banner, index) => ({
      ...banner,
      orden: index + 1 
    }));

    const ordenActualIds = this.listaBanners.map(b => b.idBanner).join(',');
    const cambioDetectado = this.ordenOriginalIds !== ordenActualIds;

    this.ordenCambiado.emit({
      lista: this.listaBanners,
      cambioDetectado: cambioDetectado
    });
  }

  showAlert(title:string ,message:string){
    Swal.fire({
      title: title,
      text:  message,
      confirmButtonColor: '#545D6E',
      confirmButtonText: '<span style="color: #ffffff"> Entendido </span>',
    })
  }

}
